import KeyFlowParamVO from './KeyFlowParamVO';

export type StatisticsExportParamVOProps = {
  taskType?: ExportTaskType;
  // yyyyMMdd
  startDate?: string;
  endDate?: string;
};

export enum ExportTaskType {
  Asset = 'ASSET',
  Partial = 'PARTIAL',
  Download = 'DOWNLOAD',
  Login = 'LOGIN',
}

class StatisticsExportParamVO extends KeyFlowParamVO {
  TASK_TYPE?: ExportTaskType;
  // yyyyMMdd
  START_DATE?: string;
  END_DATE?: string;

  constructor(data: StatisticsExportParamVOProps) {
    super();
    this.TASK_TYPE = data.taskType;
    this.START_DATE = data.startDate;
    this.END_DATE = data.endDate;
  }
}

export default StatisticsExportParamVO;
